import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { LogOut, Compass } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F4F4F0]/80 border-b border-[#E5E5E0]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 py-4 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group min-w-0">
          <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center shrink-0">
            <Compass className="w-4 h-4 text-white" strokeWidth={2} />
          </div>
          <span className="font-heading font-black text-lg sm:text-xl tracking-tight truncate">
            CareerWisdom
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            data-testid="nav-home"
            className="text-sm font-semibold text-[#0A0A0A] hover:text-[#002FA7] transition-colors"
          >
            Home
          </Link>
          {user && (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="text-sm font-semibold text-[#0A0A0A] hover:text-[#002FA7] transition-colors"
              >
                Dashboard
              </Link>
              <Link
                to="/quiz"
                data-testid="nav-retake-quiz"
                className="text-sm font-semibold text-[#0A0A0A] hover:text-[#002FA7] transition-colors"
              >
                Take Quiz
              </Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2">
                {user.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="w-7 h-7 rounded-full border border-[#E5E5E0]"
                    data-testid="user-avatar"
                  />
                )}
                <span className="text-sm font-medium" data-testid="user-name">{user.name?.split(" ")[0]}</span>
              </div>
              <button
                data-testid="logout-button"
                onClick={handleLogout}
                className="p-2 hover:bg-[#E5E5E0] rounded-sm transition-colors"
                title="Sign out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <button
              data-testid="login-button"
              onClick={handleLogin}
              className="btn-primary shrink-0 !px-3 !py-2 !text-sm sm:!px-6 sm:!py-3 sm:!text-base"
            >
              <span className="sm:hidden">Sign in</span>
              <span className="hidden sm:inline">Sign in with Google</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
